import { PageFormsData, PageFormsElementsData } from "../types/hexpertTypes"
export enum UnitTypes {
    PRESSURE = 'pressure',
    TEMPERATURE = 'temperature',
    POWER = 'power'
}

export enum UnitSystem {
    STANDARD = 'standard',
    METRIC = 'metric',
    IMPERIAL = 'imperial'
}

export const unitConverter = (type: UnitTypes, system: UnitSystem, unit) => {
    switch (type) {
        case UnitTypes.PRESSURE:
            switch (system) {
                case UnitSystem.IMPERIAL:
                    return unit * 14.503773773 // bar to psi
                case UnitSystem.METRIC:
                    return unit * 100
                default:
                    return unit
            }
        case UnitTypes.TEMPERATURE:
            switch (system) {
                case UnitSystem.IMPERIAL:
                    return unit * (9 / 5) + 32 // C to F
                default:
                    return unit
            }
        case UnitTypes.POWER:
            switch (system) {
                case UnitSystem.IMPERIAL:
                    return unit / 293.07107 // kw to MMBtu/hr
                case UnitSystem.METRIC:
                    return unit / 0.860421 // kw to Mcal/hr
                default:
                    return unit
            }
        default:
            return unit
    }
}

export const unitConvertName = (type: UnitTypes, system: UnitSystem) => {
    switch (type) {
        case UnitTypes.PRESSURE:
            switch (system) {
                case UnitSystem.STANDARD:
                    return 'Bar'
                case UnitSystem.IMPERIAL:
                    return 'psi'
                case UnitSystem.METRIC:
                    return 'kPa'
                default:
                    return 'Bar'
            }
        case UnitTypes.TEMPERATURE:
            switch (system) {
                case UnitSystem.STANDARD:
                    return '°C'
                case UnitSystem.IMPERIAL:
                    return '°F'
                case UnitSystem.METRIC:
                    return '°C'
                default:
                    return '°C'
            }
        case UnitTypes.POWER:
            switch (system) {
                case UnitSystem.STANDARD:
                    return 'kW'
                case UnitSystem.IMPERIAL:
                    return 'MMBtu/hr'
                case UnitSystem.METRIC:
                    return 'Mcal/hr'
                default:
                    return 'kW'
            }
        default:
            return ''
    }
}

export const powerConversionRate = (system: UnitSystem) => {
    switch (system) {
        case UnitSystem.IMPERIAL:
            return '1kW = 0.0034 MMBtu'
        case UnitSystem.METRIC:
            return '1kW = 0.860421 Mcal'
        default:
            return 'kW'
    }
}

export const getUnitForField = (fieldId: string, forms: PageFormsData[]) => {
    const allForms: PageFormsElementsData[] = []
    forms.forEach(form => allForms.push(...form.Value?.ElementsArea))
    const findBlock = allForms?.find(f => f.FieldId === fieldId)
    if (findBlock.ContentType === 'HexpertPressureChoiceElementBlock') {
        return unitConvertName(UnitTypes.PRESSURE, UnitSystem.STANDARD)
    }
    if (findBlock.ContentType === 'HexpertTemperatureChoiceElementBlock') {
        return unitConvertName(UnitTypes.TEMPERATURE, UnitSystem.STANDARD)
    }
    if (findBlock.ContentType === 'HexpertPowerRangeElementBlock') {
        return unitConvertName(UnitTypes.POWER, UnitSystem.STANDARD)
    }
    return ''
}